import _extends from "@babel/runtime/helpers/extends";
import { Button, Divider, Modal, Alert, Image } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { IMPREZA_BUTTON_PROPS, __ } from "../../../utils";
import { AccountInstallationsTable, AccountLicensesTable, AccountAddLicenseForm } from ".";
import { PlusOutlined } from "@ant-design/icons";
import { ESubscriptionCancellationReason, ESubscriptionStatus } from "@devowl-wp/api-real-commerce";
const AccountSubscriptionExpand = observer(_ref => {
  var _productPlanDescripti;
  let {
    record
  } = _ref;
  const {
    data: {
      id,
      status,
      cancellationReason,
      productPlan: {
        product: {
          id: productId
        },
        description: productPlanDescription
      }
    },
    canBeModified
  } = record;
  const [isAddNewLicenseVisible, setIsAddNewLicenseVisible] = useState(false);
  if (status === ESubscriptionStatus.Canceled || status === ESubscriptionStatus.CancellationPending && cancellationReason === ESubscriptionCancellationReason.PaymentFailed) {
    return /*#__PURE__*/React.createElement(Alert, {
      type: "error",
      showIcon: true,
      message: __("Your subscription has expired. Therefore, you can no longer manage licenses and download updates.")
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, record.isInstallableProduct ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: 0
    },
    orientation: "left"
  }, __("Products")), /*#__PURE__*/React.createElement(AccountInstallationsTable, {
    records: record.installations
  }), /*#__PURE__*/React.createElement(Divider, {
    orientation: "left"
  }, __("Licenses"), "\xA0", canBeModified && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    open: isAddNewLicenseVisible,
    title: __("Add license"),
    okText: __("Create license"),
    cancelText: __("Cancel"),
    onCancel: () => setIsAddNewLicenseVisible(false),
    okButtonProps: {
      form: `add-license-form-${id}`,
      htmlType: "submit",
      ...IMPREZA_BUTTON_PROPS
    }
  }, /*#__PURE__*/React.createElement(AccountAddLicenseForm, {
    record: record,
    onSave: () => setIsAddNewLicenseVisible(false)
  })), /*#__PURE__*/React.createElement(Button, _extends({
    type: "primary",
    onClick: () => setIsAddNewLicenseVisible(!isAddNewLicenseVisible)
  }, IMPREZA_BUTTON_PROPS), /*#__PURE__*/React.createElement(PlusOutlined, null), " ", __("Add license")))), /*#__PURE__*/React.createElement(AccountLicensesTable, {
    records: record.licenses
  }), +productId === 1 && +((_productPlanDescripti = productPlanDescription.match(/(\d+)/)) === null || _productPlanDescripti === void 0 ? void 0 : _productPlanDescripti[0]) >= 10 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    orientation: "left"
  }, __("Badges")), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, __("You want to show your customers that you use Real Cookie Banner? Include the following badges or the Real Cookie Banner logo on your website! You can find them in various formats in the press kit.")), /*#__PURE__*/React.createElement(Image.PreviewGroup, null, [__("https://assets.devowl.io/in-app/wp-real-cookie-banner/agency-badge/en/2x/agency-badge-1-to-1.0-en@2x.png"), __("https://assets.devowl.io/in-app/wp-real-cookie-banner/agency-badge/en/2x/agency-badge-1-to-1.8-en@2x.png"), __("https://assets.devowl.io/in-app/wp-real-cookie-banner/agency-badge/en/2x/agency-badge-1-to-3.0-en@2x.png")].map(url => /*#__PURE__*/React.createElement(Image, {
    key: url,
    height: 150,
    src: url,
    wrapperStyle: {
      marginRight: 10,
      marginBottom: 10
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 15
    }
  }, /*#__PURE__*/React.createElement(Button, _extends({
    href: __("https://devowl.io/go/real-cookie-banner/press-kit-latest-zip")
  }, IMPREZA_BUTTON_PROPS), __("Download press kit"))))) : /*#__PURE__*/React.createElement(Alert, {
    type: "info",
    showIcon: true,
    message: __("This product is a service. For this reason, no further details are visible here, such as active installations or licenses to be managed. You have already been notified by e-mail with further instructions. Please check your spam folder if you do not find the email!")
  }));
});
export { AccountSubscriptionExpand };